module.exports = __webpack_public_path__ + "static/img/hyy.70f570d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hyy.jpg
// module id = CBPN
// module chunks = 1